angular
    .module('empower.contactUs')
    .service('contactUsService', ['$rootScope', '$filter', '$q', 'httpService',
        function ($rootScope, $filter, $q, httpService) {
            return {
                sendFeedback: sendFeedback
            };

            function sendFeedback(params) {
                var def = $q.defer(),
                    APITarget = "api/common/feedback",
                    Values = JSON.stringify({
                        Identifier: $rootScope.user.Identifier,
                        SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
                        DateOfBirth: $rootScope.user.DateOfBirth,
                        IsClaimant: $rootScope.user.IsClaimant,
                        Subject: params.EnquiryType,
                        Message: params.Message,
                        PolicyId: params.PolicyId,
                        ClaimId: params.ClaimId,
                        BusinessUnit: params.BusinessUnit,
                        EnquiryType: params.EnquiryType,
                        UploadSession: params.UploadSession
                    });

                httpService.httpRequest(APITarget, Values, 'POST').then(function (data) {
                    if (data !== false) {
                        if (data === "logout") {
                            $rootScope.userLogout();
                        }
                        def.resolve(angular.fromJson(data)); // PolicyDetails
                    } else {
                        def.reject();
                    }
                });

                return def.promise;
            }
        }
    ]);